type lng = 'fi' | 'en'

export const getAtDayString = (weekNumber: number, lng: lng = 'fi') => {
	if (lng === 'fi') {
		switch (weekNumber) {
			case 1:
				return 'Maanantaina'
			case 2:
				return 'Tiistaina'
			case 3:
				return 'Keskiviikkona'
			case 4:
				return 'Torstaina'
			case 5:
				return 'Perjantaina'
			case 6:
				return 'Lauantaina'
			case 7:
				return 'Sunnuntaina'
			default:
				return 'unknown'
		}
	} else {
		switch (weekNumber) {
			case 1:
				return 'Monday'
			case 2:
				return 'Tuesday'
			case 3:
				return 'Wednesday'
			case 4:
				return 'Thursday'
			case 5:
				return 'Friday'
			case 6:
				return 'Saturday'
			case 7:
				return 'Sunday'
			default:
				return 'unknown'
		}
	}
}

export const parseWeekDay = (weekNumber: number, lng: lng = 'fi') => {
	if (lng === 'fi') {
		switch (weekNumber) {
			case 1:
				return 'Maanantai'
			case 2:
				return 'Tiistai'
			case 3:
				return 'Keskiviikko'
			case 4:
				return 'Torstai'
			case 5:
				return 'Perjantai'
			case 6:
				return 'Lauantai'
			case 7:
				return 'Sunnuntai'
			default:
				return 'unknown'
		}
	} else {
		switch (weekNumber) {
			case 1:
				return 'Monday'
			case 2:
				return 'Tuesday'
			case 3:
				return 'Wednesday'
			case 4:
				return 'Thursday'
			case 5:
				return 'Friday'
			case 6:
				return 'Saturday'
			case 7:
				return 'Sunday'
			default:
				return 'unknown'
		}
	}
}

export const getMonthString = (index: number, lng: lng = 'fi') => {
	if (lng === 'fi') {
		switch (index) {
			case 1:
				return 'Tammikuu'
			case 2:
				return 'Helmikuu'
			case 3:
				return 'Maaliskuu'
			case 4:
				return 'Huhtikuu'
			case 5:
				return 'Toukokuu'
			case 6:
				return 'Kesäkuu'
			case 7:
				return 'Heinäkuu'
			case 8:
				return 'Elokuu'
			case 9:
				return 'Syyskuu'
			case 10:
				return 'Lokakuu'
			case 11:
				return 'Marraskuu'
			case 12:
				return 'Joulukuu'
			default:
				return '-'
		}
	} else {
		switch (index) {
			case 1:
				return 'January'
			case 2:
				return 'February'
			case 3:
				return 'March'
			case 4:
				return 'April'
			case 5:
				return 'May'
			case 6:
				return 'June'
			case 7:
				return 'July'
			case 8:
				return 'August'
			case 9:
				return 'September'
			case 10:
				return 'October'
			case 11:
				return 'November'
			case 12:
				return 'December'
			default:
				return '-'
		}
	}
}

export const getShortMonthString = (index: number, lng: lng = 'fi') => {
	if (lng === 'fi') {
		switch (index) {
			case 1:
				return 'Tammi'
			case 2:
				return 'Helmi'
			case 3:
				return 'Maalis'
			case 4:
				return 'Huhti'
			case 5:
				return 'Touko'
			case 6:
				return 'Kesä'
			case 7:
				return 'Heinä'
			case 8:
				return 'Elo'
			case 9:
				return 'Syys'
			case 10:
				return 'Loka'
			case 11:
				return 'Marras'
			case 12:
				return 'Joulu'
			default:
				return '-'
		}
	} else {
		switch (index) {
			case 1:
				return 'Jan'
			case 2:
				return 'Feb'
			case 3:
				return 'Mar'
			case 4:
				return 'Apr'
			case 5:
				return 'May'
			case 6:
				return 'Jun'
			case 7:
				return 'Jul'
			case 8:
				return 'Aug'
			case 9:
				return 'Sep'
			case 10:
				return 'Oct'
			case 11:
				return 'Nov'
			case 12:
				return 'Dec'
			default:
				return '-'
		}
	}
}

export const getWeekString = (index: number, lng: lng = 'fi') => {
	if (lng === 'fi') {
		switch (index) {
			case 1:
				return 'Maanantai'
			case 2:
				return 'Tiistai'
			case 3:
				return 'Keskiviikko'
			case 4:
				return 'Torstai'
			case 5:
				return 'Perjantai'
			case 6:
				return 'Lauantai'
			case 7:
				return 'Sunnuntai'
			default:
				return ''
		}
	} else {
		switch (index) {
			case 1:
				return 'Monday'
			case 2:
				return 'Tuesday'
			case 3:
				return 'Wednesday'
			case 4:
				return 'Thursday'
			case 5:
				return 'Friday'
			case 6:
				return 'Saturday'
			case 7:
				return 'Sunday'
			default:
				return ''
		}
	}
}
